import { render, staticRenderFns } from "./Notifikacije.vue?vue&type=template&id=2d8f73f6&scoped=true&"
import script from "./Notifikacije.vue?vue&type=script&lang=js&"
export * from "./Notifikacije.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8f73f6",
  null
  
)

export default component.exports